<template>
  <div class="work">
    <Header title="调课审核" type="0" route="/new/Home"></Header>
    <qz-tabbar :tabProps="tabProps"></qz-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 审核类型
      cardType: sessionStorage.getItem("cardType") || ""
    };
  },
  created() {
  },
  computed: {
    tabProps() {
      return [
        {
          label: "我的审核",
          route: "/tksh/unpass",
          icon: "quanbu"
        },
        {
          label: "审核记录",
          route: "/tksh/pass",
          icon: "jiluhui"
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/teacher/tksh/index.vue